import React, { createContext, useState, useEffect, useMemo, useCallback } from "react";
import axios from "axios";
import API_BASE_URL from "../config/api";

export const publicationContext = createContext("");

export const PublicationContextProvider = ({ children }) => {
  const [listPublications, setListPublication] = useState([]);
  const [title, setTitle] = useState("");
  const [publicationBody, setPublicationBody] = useState("");
  const [publicationUrl, setPublicationUrl] = useState("");
  const [publicationUnikId, setPublicationUnikId] = useState("");

  // Create Publication
  const handleNewPublication = useCallback(() => {
    const data = {
      title,
      publicationBody,
      publicationUrl,
    };

    axios
      .post(`${API_BASE_URL}/publications`, data, {
        headers: {
          myToken: localStorage.getItem("myToken"),
        },
      })
      .then((res) => {
        if (res.data.error) {
          alert("Veuillez d'abord vous authentifier");
        } else {
          setListPublication((prevPublications) => [
            ...prevPublications,
            {
              title,
              publicationBody,
              publicationUrl,
            },
          ]);
        }
      })
      .catch((error) => console.log(error));
  }, [title, publicationBody, publicationUrl]);

  // Save Publication
  const handleSavePublication = useCallback(() => {
    setListPublication((prevPublications) => [
      ...prevPublications,
      {
        title,
        publicationBody,
        publicationUrl,
      },
    ]);
  }, [title, publicationBody, publicationUrl]);

  // Delete Publication
  const handleDeletePublication = useCallback((publicationId) => {
    axios
      .delete(`${API_BASE_URL}/publications/${publicationId}`, {
        headers: {
          myToken: localStorage.getItem("myToken"),
        },
      })
      .then((res) => {
        if (res.data.error) {
          alert("Veuillez d'abord vous authentifier");
        } else {
          alert("Publication supprimée avec succès");
          setListPublication((prevPublications) =>
            prevPublications.filter((publication) => publication._id !== publicationId)
          );
        }
      })
      .catch((error) => console.log(error));
  }, []);

  // Fetch Publications
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/publications`)
      .then((response) => setListPublication(response.data))
      .catch((error) => console.log(error));
  }, []);

  const contextValue = useMemo(
    () => ({
      handleDeletePublication,
      handleNewPublication,
      handleSavePublication,
      title,
      setTitle,
      publicationBody,
      setPublicationBody,
      publicationUrl,
      setPublicationUrl,
      listPublications,
      setListPublication,
      publicationUnikId,
      setPublicationUnikId,
    }),
    [
      handleDeletePublication,
      handleNewPublication,
      handleSavePublication,
      title,
      setTitle,
      publicationBody,
      setPublicationBody,
      publicationUrl,
      setPublicationUrl,
      listPublications,
      setListPublication,
      publicationUnikId,
      setPublicationUnikId,
    ]
  );

  return (
    <publicationContext.Provider value={contextValue}>
      {children}
    </publicationContext.Provider>
  );
};
